<template>
    <v-data-table
        :items="rows"
        :headers="columns"
    >
        <template v-slot:items="row">
            <tr v-for="data in row.item" :key="data['id']">
                <td  v-for="column in columns" :key="column['key']">
                    {{ row.item[0] }}
                    <span v-if="column.type == 'text'">{{ data[column.value] }}</span>
                    <span v-else-if="column.type == 'button'">
                        <v-btn v-for="button in data.button" :key="button['id']">
                            {{ button.text }}
                        </v-btn>
                    </span>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>
<script>
export default {
    props:['columns','rows']
}
</script>

